import MinhaSaude from "@/pages/minha-saude/index.vue";

const routes: Route[] = [
  {
    path: "/minha-saude",
    name: "minha_saude",
    component: MinhaSaude,
    meta: {
      checkPathDisabled: true,
      requiresNativeCapability: "health",
      allowWebFallback: true,
      backTo: "/"
    }
  }
];

export default routes;
